import React from 'react';
import HeroSection from '../components/yelp/HeroSection';
import FeaturesSection from '../components/yelp/FeaturesSection';
import ExperienceSection from '../components/yelp/ExperienceSection';
import TourCTASection from '../components/yelp/TourCTASection';
import UrgencySection from '../components/yelp/UrgencySection';
import ReviewsSection from '../components/yelp/ReviewsSection';
import FAQSection from '../components/yelp/FAQSection';
import FinalCTASection from '../components/yelp/FinalCTASection';

const YelpLandingPage = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('inquiry-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-padua-ivory font-sans text-padua-charcoal">
      <HeroSection onCtaClick={scrollToForm} />
      <FeaturesSection />
      <ExperienceSection />
      <TourCTASection onCtaClick={scrollToForm} />
      <UrgencySection onCtaClick={scrollToForm} />
      <ReviewsSection />
      <FAQSection />
      <FinalCTASection id="inquiry-form" />
      
      <footer className="bg-padua-charcoal text-padua-ivory py-16 text-center relative">
        <div className="absolute top-0 left-0 w-full h-1 bg-padua-gold opacity-30" />
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="font-serif text-3xl mb-4">Padua Weddings</h2>
          <p className="text-padua-gold font-bold tracking-[0.3em] uppercase text-[10px] mb-8">Claremont's Historic Estate</p>
          <div className="w-12 h-px bg-padua-gold/30 mx-auto mb-8" />
          <p className="text-sm text-padua-ivory/60 mb-2">4467 Padua Ave, Claremont, CA</p>
          <p className="text-xs text-padua-ivory/40">&copy; {new Date().getFullYear()} Padua Weddings. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default YelpLandingPage;